import {useRef} from 'react'
import {SDrawerOrModal, SGeneralForms} from 'shj-components'
import {Button, message, Spin} from 'antd'
import {useSetState} from 'ahooks'
import {startDurationFlow} from '@/services/order'
import {getEnums} from "@/services/homeService.ts";
import {httpDictServTenant} from "@/services/fmsServices.ts";

interface IProps {
    title: string
    orderId: string
    open: boolean
    setOpen: (open: boolean) => void
}

export default function StartWorkPending(prpos: IProps) {
    const formRef = useRef(null)
    const {open, title, setOpen, orderId} = prpos
    const [state, setState] = useSetState<any>({
        loading: false,
        errInfo: [],
        btnLoading: false,
    })

    const onFormRef = () => {
        const {onFormRef} = formRef.current || {}
        return onFormRef?.()
    }

    const onsubmit = () => {
        onFormRef()?.validateFields().then(values => {
            const data = {
                ...values,
                orderId,
                applyType: "bePending",
            }
            console.log('提交数据', data)
            setState({btnLoading: true})
            // 提交
            startDurationFlow(data).then(() => {
                message.success('提交成功')
                onCancel()
            })
                .finally(() => {
                    setState({btnLoading: false})
                })
        })
    }

    const onCancel = () => {
        onFormRef()?.resetFields()
        setOpen(false)
    }

    const httpOptionsFn = async () => {
        const reasonList: any = await httpDictServTenant({
            "orderBys": [
                {
                    "columnName": "sortNumber",
                    "asc": true
                }
            ],
            parentKey: 'bePendingReason',
            enable: 1,
        });
        return Promise.resolve({reasonList})
    }
    return (
        <SDrawerOrModal
            title={title}
            mode="modal"
            open={open}
            width={500}
            onCancel={onCancel}
            antdProps={{
                footer: (
                    <div>
                        <Button onClick={onCancel}>取消</Button>
                        <Button
                            style={{marginLeft: 15}}
                            loading={state.btnLoading}
                            type="primary"
                            onClick={onsubmit}
                        >
                            提交
                        </Button>
                    </div>
                ),
            }}
        >
            {open && (
                <div>
                    <Spin spinning={state.loading}>
                        <div>
                            <SGeneralForms
                                ref={formRef}
                                layout={'vertical'}
                                httpOptionsFn={httpOptionsFn}
                                configs={[
                                    {
                                        formItem: [
                                            {
                                                spanCol: 24,
                                                label: '选择延期原因',
                                                name: 'reason',
                                                type: 'select',
                                                data: 'reasonList',
                                                required: true,
                                                comConfig: {
                                                    fieldNames: {label: 'name', value: 'priKey'},
                                                },
                                                required: true,
                                                spanCol: 24,
                                            },
                                            {
                                                spanCol: 24,
                                                label: '原因描述',
                                                name: 'description',
                                                type: 'textarea',
                                                required: true,
                                                comConfig: {showCount: true, maxLength: 200},
                                            },
                                        ],
                                    },
                                ]}
                            />
                        </div>
                    </Spin>
                </div>
            )}
        </SDrawerOrModal>
    )
}
